export default __webpack_public_path__ + "static/media/Arrow.8561e379.svg";